<div class="card">
  <div class="flex-row align-items-center p-4 white-bg" style="flex-wrap: wrap">
    <ts-paginated-search-header class="flex-grow-1" [searchValue]="searchTerm$ | async"
      (searchChanged)="searchTermChanged($event)" [previousTokens]="previousAlgorithmTokens$ | async"
      [lastItem]="nextAlgorithmToken$ | async" [length]="totalCount$ | async" [pageSize]="pageSize$ | async"
      [pageSizeOptions]="pageSizeOptions" [disabled]="loading$ | async" (pageChange)="handlePageEvent($event)"
      (pageSizeChange)="changePageSize($event)" [counting]="counting$ | async"></ts-paginated-search-header>

    <div class="filters-row">
      <mat-form-field appearance="outline" class="filter-half">
        <mat-label>{{ 'core.environment' | translate }}</mat-label>
        <mat-select [value]="environmentFilter$ | async" (selectionChange)="environmentFilterChanged($event.value)">
          <mat-option [value]="undefined">{{ 'core.all' | translate }}</mat-option>
          <mat-option [value]="ExecutionEnvironment.CLOUD">{{ 'core.cloud' | translate }}</mat-option>
          <mat-option [value]="ExecutionEnvironment.MOBILE">{{ 'core.edge' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-half">
        <mat-label>Deprecation</mat-label>
        <mat-select [value]="includeDeprecated$ | async" (selectionChange)="includeDeprecatedChanged($event.value)">
          <mat-option [value]="false">{{ 'table.algorithms.filters.only_active' | translate }}</mat-option>
          <mat-option [value]="true">{{ 'table.algorithms.filters.include_deprecated' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <ts-algorithm-list [items]="algorithms$ | async" [loading]="loading$ | async" [noAlgorithms]="noAlgorithms$ | async"
    [language]="(currentLanguage$ | async) || 'en'" [columns]="columns" [usages]="usages$ | async"
    (deprecateClicked)="onDeprecateClicked($event)" (usageRequested)="onUsageRequested($event)"
    (editPipelineStep)="editAlgorithmInPipelineStep($event)"
    (deleteFromPipelineStep)="deleteAlgorithmFromPipelineStep($event)" (navigateToPipeline)="navigateToPipeline($event)"
    (editClicked)="onEditClicked($event)"></ts-algorithm-list>
</div>
